import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  MANDATORY_WEIGHING_ACTION_OPTIONS,
  MANDATORY_WEIGHING_EVENT_LABELS
} from '../../../utils/mandatoryWeighingResponse';

export default {
  name: 'MandatoryWeighingEventConfig',
  components: { VueElementLoading },
  data() {
    return {
      isLoading: false,
      savingEventKey: '',
      createdBy: '',
      token: window.localStorage.getItem('access_token') || '',
      actionOptions: MANDATORY_WEIGHING_ACTION_OPTIONS,
      eventRows: [],
      lmSyncMessage: ''
    };
  },
  mounted() {
    const enc = window.localStorage.getItem('userdetail');
    if (enc) {
      const bytes = CryptoJS.AES.decrypt(enc.toString(), 'Key');
      const userdetail = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.createdBy = userdetail[0].email;
    }
    this.loadEventConfig();
  },
  methods: {
    eventLabel(eventKey) {
      return MANDATORY_WEIGHING_EVENT_LABELS[eventKey] || eventKey;
    },
    authHeaders() {
      return {
        authorization: 'authkey xB84JJ89Hd25',
        requestfrom: 'WEB',
        token: this.token
      };
    },
    loadEventConfig() {
      this.isLoading = true;
      this.lmSyncMessage = '';
      axios.get(apiUrl.api_url_hubops + 'getMandatoryWeighingEventConfig', {
        headers: this.authHeaders()
      })
        .then((result) => {
          if (result.data.ResultCode === 100) {
            this.eventRows = (result.data.ResponseData || []).map((row) => ({
              eventKey: row.eventKey,
              defaultAction: (row.defaultAction || 'warning').toLowerCase(),
              exceptionAction: (row.exceptionAction || 'warning').toLowerCase(),
              isActive: row.isActive !== false,
              lastModifiedBy: row.lastModifiedBy,
              lastModifiedDate: row.lastModifiedDate
            }));
          } else {
            this.$alertify.error(result.data.ReturnMessage || 'Failed to load event config');
          }
        })
        .catch(() => { this.$alertify.error('Error loading mandatory weighing event config'); })
        .finally(() => { this.isLoading = false; });
    },
    updateEventRow(row) {
      if (!row || !row.eventKey || this.savingEventKey) {
        return;
      }
      this.savingEventKey = row.eventKey;
      this.lmSyncMessage = '';
      axios.post(apiUrl.api_url_hubops + 'updateMandatoryWeighingEventConfig', {
        eventKey: row.eventKey,
        defaultAction: row.defaultAction,
        exceptionAction: row.exceptionAction,
        isActive: row.isActive === true,
        lastModifiedBy: this.createdBy
      }, { headers: this.authHeaders() })
        .then((result) => {
          if (result.data.ResultCode === 100) {
            const data = result.data.ResponseData || {};
            row.defaultAction = (data.defaultAction || row.defaultAction).toLowerCase();
            row.exceptionAction = (data.exceptionAction || row.exceptionAction).toLowerCase();
            row.isActive = data.isActive !== false;
            this.$alertify.success(result.data.ReturnMessage || 'Updated successfully');
            if (data.lmSync && data.lmSync.attempted) {
              this.lmSyncMessage = data.lmSync.success
                ? `LM sync successful for ${row.eventKey}.`
                : `HubOps saved; LM sync failed (${data.lmSync.lmMessage || 'unknown error'}).`;
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage || 'Update failed');
          }
        })
        .catch(() => { this.$alertify.error('Error updating event config'); })
        .finally(() => { this.savingEventKey = ''; });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/MandatoryWeighingEventConfig/MandatoryWeighingEventConfig.js